export const {
  BASE_URL, // value -> "/"
  DEV, // true or false
  PROD, // true or false
  VITE_NODE_ENV, // comes from defined .env files
  VITE_USER_NODE_ENV, // value -> "development"
  VITE_CONTROL_CENTER_BASE_URL,
  VITE_CONTROL_CENTER_FEATURES_BASE_URL,
  VITE_APIGEE_BASE_URL,
  VITE_APIGEE_PROVISION_API_BASE_URL,
  VITE_WALLET_IS_TEST_ENVIRONMENT,
  VITE_CLIENT_MODE,
  VITE_CONTROL_CENTER_WALLET_CTID,
  VITE_PROFILE_CONFIG,
  VITE_SPLUNK_RUM_AUTH,
  VITE_SPLUNK_RUM_ENV,
} = import.meta.env;
